import { createFileRoute, Outlet } from '@tanstack/react-router'

import { BlueHeader } from '@/components/layout/blue-header'

export const Route = createFileRoute('/_blue_header')({
  component: BlueHeaderLayout,
})

function BlueHeaderLayout() {
  return (
    <div className="flex min-h-full w-full flex-col bg-[url('/images/default-background.jpg')] bg-cover bg-fixed bg-center bg-no-repeat">
      <BlueHeader />
      <div className="flex w-full flex-1 flex-col gap-6 bg-white px-4 py-8 md:px-28">
        <Outlet />
      </div>
    </div>
  )
}
